import React, { useState, useEffect } from 'react'
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const Input = ({ label, value, name, id, onChange, size, data, noOption, required, disabled, variant="standard",customCSS={} }) => {
    const [inputValue, setInputValue] = useState("")

    const inputChange = (e) => {
        setInputValue(e.target.value)
        onChange(e.target.value)
    }

    useEffect(() => {
        setInputValue(value)
    }, [value])

    return (
        <FormControl fullWidth size={size !== undefined ? size : ''} variant={variant} sx={customCSS}>
            <InputLabel required={required !== undefined ? required : false} id={id !== undefined ? id : ''} >{label !== undefined ? label : ''}</InputLabel>
            <Select
                // variant='filled'
                labelId={id !== undefined ? id : ''}
                value={inputValue !== null ? inputValue : ''}
                label={label !== undefined ? label : ''}
                onChange={e => inputChange(e)}
                name={name !== undefined ? name : ''}
                id={id !== undefined ? id : ''}
                required={required !== undefined ? required : false}
                // variant='filled'
                disabled={disabled ? disabled : false}

            >
                <MenuItem value={''}>{'Select Option'}</MenuItem>
                {data !== undefined && data.length > 0 ?
                    data.map((item, i) => {
                        return (
                            noOption !== item.code ?
                                <MenuItem key={i} value={item.code}>{item.name}</MenuItem>
                                : null
                        )
                    })
                    : null}
            </Select>
        </FormControl>
    )
}

export default Input;